import { Vue } from 'vue-class-component';
import { Options, Prop } from 'vue-property-decorator';

@Options({})
export default class PageHeader extends Vue {

  @Prop({ default: 'App Logo'})
  private appName!: string;

}
